import { Unpin, UnpinVariables } from './__generated__/Unpin'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation Unpin($input: RemovePinnedMessageInputV2!) {
    unpinMessageFromBoardV2(input: $input) {
      ... on PinnedMessageErrorV2 {
        type
        error
      }
      ... on PinnedMessageV2 {
        id
      }
    }
  }
`

export const useUnpin = () => {
  return useMutation<Unpin, UnpinVariables>(MUTATION)
}
